import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { API } from '../api';

import './DetalleDestino.css';

function DetalleDestino() {
  const { id } = useParams();
  const [destino, setDestino] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fotos, setFotos] = useState([]);

  useEffect(() => {
         window.scrollTo(0,0);
    const fetchDestino = async () => {
      try {
        const res = await API.get(`destinos/${id}/`);
        setDestino(res.data);

        const fotosRes = await API.get('galeria/');
        const fotosDestino = fotosRes.data.filter(
          f => f.destino === Number(id)
        );
        setFotos(fotosDestino);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchDestino();
  }, [id]);

  if (loading) return <p>Cargando...</p>;
  if (!destino) return <p>No se encontró el destino</p>;

  const limpiarTexto = (texto) => {
  if (!texto) return "";
  return texto
    .replace(/\r\n/g, "\n")
    .replace(/\n{2,}/g, "\n")
    .trim();
};


  return (
    <>
      {/* HERO */}
      <div className="hero-destino">
        <div className="hero-inner">

          <div className="hero-contenido">
            <div className="breadcrumbs">
              Destinos › {destino.nombre}
            </div>

            <h1 className="hero-titulo">
              {destino.nombre}
            </h1>

            <p className="hero-subtitulo">
              {destino.frase}
            </p>

            <div className="hero-rating">
              ⭐⭐⭐⭐⭐ <span>4.8 (120 reseñas)</span>
            </div>
          </div>

          <div className="hero-imagen">
            {fotos[0] && (
              <img src={fotos[0].imagen} alt={destino.nombre} />
            )}
          </div>

        </div>
      </div>
{/* CONTENIDO */}
<div className="detalle-page">
  <div className="detalle-layout">

    {/* IZQUIERDA */}
    <div className="detalle-left">

      {/* SOBRE ESTE DESTINO + FOTO */}
      <section className="card bloque-media">
        <div>
          <h2 className="titulo-seccion">Sobre este destino</h2>
          <p>{destino.descripcion}</p>
        </div>

        {fotos[1] && (
          <img src={fotos[1].imagen} alt="" />
        )}
      </section>


      {/* ITINERARIO */}
      <section className="card itinerario-section">

        <h2 className="titulo-seccion">Itinerario</h2>

        <div className="itinerario-pro">
          {limpiarTexto(destino.itinerario).split("\n").map((linea, i) => {

            const texto = linea.toLowerCase()

            const esTitulo =
              texto.includes("día") ||
              texto.includes("mediodía") ||
              texto.includes("tarde") ||
              texto.includes("noche")

            return (
              <div
                key={i}
                className={esTitulo ? "dia-itinerario" : "actividad-itinerario"}
              >
                {linea}
              </div>
            )
          })}
        </div>

      </section>


      {/* INFORMACIÓN DEL VIAJE */}
      <section className="seccion-info">

        <h2 className="titulo-seccion">Información del viaje</h2>

        {/* DURACIÓN / FRECUENCIA */}
        <section className="card grid-2">

          <div>
            <h3>🕒 Duración</h3>
            <p>{limpiarTexto(destino.duracion)}</p>
          </div>

          <div>
            <h3>📅 Frecuencia</h3>
            <p>{limpiarTexto(destino.frecuencia)}</p>
          </div>

        </section>


        {/* HORARIOS / EMBARQUE */}
        <section className="card grid-2">

          <div>
            <h3>🕒 Horarios</h3>
            <ul className="lista-info">
              {limpiarTexto(destino.horarios).split("\n").map((item,i)=>(
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h3>📍 Punto de embarque</h3>
            <ul className="lista-info">
              {limpiarTexto(destino.puntos_embarque).split("\n").map((item,i)=>(
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

        </section>

        {/* TRANSPORTE */}
        <section className="card">

          <h3>🚌 Transporte</h3>

          <ul className="lista-info">
            {limpiarTexto(destino.transporte).split("\n").map((item,i)=>(
              <li key={i}>{item}</li>
            ))}
          </ul>

        </section>

      </section>

      {/* DETALLES DEL TOUR */}
      <section className="seccion-info">

        <h2 className="titulo-seccion">Detalles del tour</h2>

        {/* INCLUYE / QUE LLEVAR */}
        <section className="card grid-2">

          <div>
            <h3>✅ Incluye</h3>
            <ul className="lista-incluye">
              {limpiarTexto(destino.incluye).split("\n").map((item,i)=>(
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <h3>🎒 Qué llevar</h3>
            <ul className="lista-info">
              {limpiarTexto(destino.que_llevar).split("\n").map((item,i)=>(
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* NO INCLUYE */}
        <section className="card">

          <div>
            <h3>❌ No incluye</h3>
            <ul className="lista-noincluye">
              {limpiarTexto(destino.no_incluye).split("\n").map((item,i)=>(
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

        </section>

      </section>

      {/* TERMINOS + FOTO */}
      <section className="card bloque-media">

        <div>
          <h2 className="titulo-seccion">Términos y condiciones</h2>

          <ul className="lista-terminos">
           {limpiarTexto(destino.terminos).split("\n").map((item,i)=>(
          <li key={i}>{item}</li>
          ))}
          </ul>
        </div>

        {fotos[3] && (
          <img src={fotos[3].imagen} alt="" />
        )}
      </section>

    </div>
{/* SIDEBAR */}
<aside className="detalle-right">
  <div className="sidebar-card">
    <h2>{destino.nombre}</h2>
    <div className="precio">
      Desde S/. {destino.precio_aprox}
    </div>

    {/* PRECIOS */}
    {destino.precios && destino.precios.length > 0 && (
      <div className="lista-precios">
        {destino.precios.map((p, i) => (
          <div key={i} className="precio-item">
            <span>{p.descripcion}</span>
            <strong>S/. {p.precio}</strong>
          </div>
        ))}
      </div>
    )}
    <Link
      to={`/reserva?destino=${destino.nombre}`}
      className="btn-primary"
    >
      Reservar ahora
    </Link>
    <Link to="/destinos" className="btn-secondary">
      ← Volver
    </Link>
  </div>
</aside>
          {/* RESERVAS */}
          <div className="reservas-box">
            <h2>📲 Reservas y Pagos</h2>
            <p>
              Reserva tu cupo con el <strong>50% de adelanto</strong>.
              Envía tu comprobante de pago junto con tus datos completos:
            </p>
           <ul className="lista-reservas">
              <li> Nombre completo</li>
              <li> DNI</li>
              <li> Destino</li>
              <li> Punto de embarque</li>
          </ul>
            <p>
              Nuestro equipo confirmará tu reserva una vez validado el pago.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default DetalleDestino;